import { isMiddyBuilding, isPowercorBuilding } from '../../utils/util';

export const getTitleByWidget = widget => {
  const {
    template: { id }
  } = widget;
  switch (id) {
    case 1:
      return 'Building Consumption';
    case 5:
      return 'Solar Generation';
    case 11:
      return 'Solar Power';
    case 12:
      return 'Weather';
    default:
      return (widget.template.id !== 13 && widget.template.id !== 14)
        ? widget.template.name
        : (widget.widget_params && widget.widget_params.load ? widget.widget_params.load.name : widget.template.name);
  }
};

export const getSubTitleByWidget = widget => {
  const {
    template: { id }
  } = widget;
  switch (id) {
    case 7:
      return 'Current Demand';
    case 11:
      return 'Current Output';
    case 12:
      if (isMiddyBuilding()) return 'Clayton';
      if (isPowercorBuilding()) return 'Weybridge';
      return 'last 24 hours';
    default:
      return 'Last 24 Hours';
  }
};

export const getColorByWidget = widget => {
  const {
    template: { id }
  } = widget;
  switch (id) {
    case 1:
      return '#5cc3d0';
    case 5:
      return '#ffd44f';
    case 11:
      return '#FF9A00';
    case 7:
      return '#e47a53';
    case 12:
      return '#00b6c5';
    case 13:
    case 14:
      return widget.widget_params
        ? widget.widget_params.background_color
        : '#5cc3d0';
    default:
      return '#5cc3d0';
  }
};
